import { useState } from "react";
import { useGlobalContext } from "../../context/GlobalContext";


export function useRealoadOnThemeToogle()
{
    let context = useGlobalContext();

    let fontColor = context.Context!.GetTheme!() == 'dark' ? 'white' : 'black';    
    
    let [reload, setReload] = useState(0);    
   
    context.Context?.AfterThemeChangeEvent.Add(()=> setReload(p => p + 1));

    return fontColor;
}